import ToolbarMenu from "./toolbar-menu"
export default (options = {}) => ({
  component: options.component || (() => "L"),
  menu: ToolbarMenu,
  onClick(event, editor, menu) {
    menu()
  }
})
